import { Cube } from "../state/types";

// De body voor POST /api/projects/<id>/parcels. Bewust alleen `type` en
// `coordinates` uit de cube-geometrie: die draagt ook `properties` (area,
// perimeter) mee, en dat hoort niet in een GeoJSON-geometrie die de backend
// als PolygonField opslaat.
export const parcelPayload = (field: Cube) => {
  const { type, coordinates } = field.geometry as unknown as {
    type: string;
    coordinates: number[][][];
  };
  return {
    name: field.name,
    geometry: { type, coordinates },
    center: { type: "Point", coordinates: field.center },
  };
};
